<template>
  <el-tabs tab-position="right" value="2">
    <el-tab-pane label="客户权限">客户权限</el-tab-pane>
    <el-tab-pane label="组权限">组权限</el-tab-pane>
    <el-tab-pane label="用户权限">
        <div class="source">
          <el-row class="querypanel">
            <el-col :span="24">
              <el-form ref="form"  label-width="120px" label-position="left">
                <el-form-item label="注册日期:">
                  <el-date-picker
                    v-model="bymemberdate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12" v-bind:hidden="showquerycusinfo">
              <el-form ref="form"  label-width="120px" label-position="left">
                <el-form-item label="客户名称:">
                  <el-select
                    v-model="customername"
                    filterable
                    placeholder="请输入客户名称">
                    <el-option
                      v-for="item in customerlist"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>

            </el-col>
            <el-col :span="12">
              <el-form ref="form"  label-width="120px" label-position="left">
                <el-form-item label="客户组名称:">
                  <el-select v-model="customergroup" placeholder="请选择用户组">
                    <el-option
                      v-for="item in customergrouplist"
                      :key="item.id.Int64"
                      :label="item.name.String"
                      :value="item.id.Int64">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="24">
              <div>
                <el-button style="margin-top: 10px; margin-left: 10px;" @click="querymember">查询会员</el-button>
              </div>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :span="24">
              <el-table
                stripe
                :data="udata"
                ref="pcusertb">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="name.String"
                  label="姓名">
                </el-table-column>
                <el-table-column
                  label="头像">
                  <template slot-scope="scope">
                    <div v-if="scope.row.imgurl.Valid && scope.row.imgurl.String !== ''">
                      <img :src="scope.row.imgurl.String" class="avatarimg">
                    </div>
                    <div v-else>
                      {{scope.row.imgurl.String}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="phone.String"
                  label="电话号码">
                </el-table-column>
                <el-table-column
                  label="操作"
                  min-width="50px"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="编辑该用户权限">
                      <i class="fa fa-eye fa-lg opicon curpointer" v-on:click="seeuser(scope.row)"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row class="querypanel">
            <el-col :span="4">
              <el-menu default-active="1-4-1" class="el-menu-vertical-demo" @select="handleSelect">
                <el-menu-item index="98">
                  <i class="el-icon-location"></i>
                  <span slot="title">基础</span>
                </el-menu-item>
                <el-menu-item index="99">
                  <i class="el-icon-menu"></i>
                  <span slot="title">业务</span>
                </el-menu-item>
                <el-menu-item index="100">
                  <i class="el-icon-document"></i>
                  <span slot="title">财务</span>
                </el-menu-item>
                <el-menu-item index="101">
                  <i class="el-icon-setting"></i>
                  <span slot="title">数据</span>
                </el-menu-item>
                <el-menu-item index="102">
                  <i class="el-icon-setting"></i>
                  <span slot="title">系统</span>
                </el-menu-item>
                <el-menu-item index="137">
                  <i class="el-icon-setting"></i>
                  <span slot="title">网站</span>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="20">
              <el-collapse v-model="activeNames" class="qxpanel" v-for="subdata in submenudata.Children" :key="String(subdata.Id)">
                <div v-if = "subdata.Children != null">
                  <el-collapse-item  :title="subdata.Name" :name="String(subdata.Id)" >
                    <el-checkbox-group @change="checkmodel" v-model="checkList" class="cdpanel">
                      <el-checkbox v-for="subsubdata in subdata.Children" :label="subsubdata.Name" :key="String(subsubdata.Id)" >{{subsubdata.Name}}</el-checkbox>
                    </el-checkbox-group>
                  </el-collapse-item>
                </div>
              </el-collapse>
            </el-col>
            <el-col :span="24">
              <div class="btnpanel">
                <el-button @click="selectall">全部选中</el-button>
                <el-button @click="cancelall">取消全选</el-button>
                <el-button @click="addqx">新增权限</el-button>
                <el-button @click="saveqx">变更权限</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
const cityOptions = ['客户信息', '用户组管理', '用户管理']
var that
export default {
  name: 'PermissionControll',
  data () {
    return {
      checkedCities1: [],
      cities: cityOptions,
      submenudata: [],
      showquerycusinfo: true,
      customerlist: [],
      customergrouplist: [],
      customergroup: '',
      customername: '',
      bymemberdate: '',
      checkList: [],
      udata: []
    }
  },
  mounted: function () {
    console.log(this)
    var v = getCookie('cusid')
    this.khid = v
    that = this
    var qcuslist, qcusgrouplist
    if (v === '1') {
      that.showquerycusinfo = false
      qcuslist = 'id > 0'
      qcusgrouplist = 'cus_id = ' + this.khid
    } else {
      that.showquerycusinfo = true
      qcusgrouplist = 'cus_id = ' + this.khid
    }
    that.$http({
      url: 'https://api.sqnetsoft.cn/customer/getcus',
      method: 'post',
      data: {
        whereinfo: {String: qcuslist, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          that.customerlist = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
    that.$http({
      url: 'https://api.sqnetsoft.cn/customer/getcususergroups',
      method: 'post',
      data: {
        whereinfo: {String: qcusgrouplist, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        if (res.data.success) {
          console.log(res.data.data)
          that.customergrouplist = JSON.parse(res.data.data)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  methods: {
    handleSelect (key, keyPath) {
      console.log(key)
      var data = JSON.parse(localStorage.getItem('models'))
      for (var j = 0; j < data[0].Children.length; j++) {
        if (key === data[0].Children[j].Id) {
          that.submenudata = data[0].Children[j]
        }
      }
      console.log(that.submenudata)
    },
    checkmodel () {
      console.log(this.checkList)
    },
    saveqx () {
      var useridlist = []
      for (var index in this.$refs.pcusertb.selection) {
        var pcuserdata = this.$refs.pcusertb.selection[index]
        useridlist.push(pcuserdata.id.Int64)
        console.log(pcuserdata)
      }
      var newdata = JSON.parse(localStorage.getItem('models'))
      var checklist = this.checkList.join(',')
      console.log(checklist)
      if (checklist === '') {
        newdata = []
      } else {
        var ifjmodel = false
        var jmodel = []
        for (var j = 0; j < newdata[0].Children.length; j++) {
          var ifhaszhi = false
          var subdata = newdata[0].Children[j]
          if (subdata) {
            if (subdata.Children.length > 0) {
              var ptmplen = subdata.Children.length
              var ifkmodel = false
              var imodel = []
              for (var i = 0; i < ptmplen; i++) {
                var subsubdata = subdata.Children[i]
                if (subsubdata) {
                  if (subsubdata.Children.length > 0) {
                    var tmplen = subsubdata.Children.length
                    console.log('执行最小级别循环')
                    var kmodel = []
                    var zmodel = false
                    for (var k = 0; k < tmplen; k++) {
                      var subsubsubdata = subsubdata.Children[k]
                      if (subsubsubdata) {
                        console.log(subsubsubdata.Name)
                        if (checklist.indexOf(subsubsubdata.Name) > -1) {
                          ifkmodel = true
                          ifhaszhi = true
                          ifjmodel = true
                          zmodel = true
                          kmodel.push(subsubsubdata)
                        }
                      }
                    }
                    if (zmodel) {
                      imodel.push(subsubdata)
                    }
                    subsubdata.Children = kmodel
                  }
                }
              }
              if (ifkmodel) {
                console.log('存在对应值')
                subdata.Children = imodel
                console.log(imodel)
              } else {
                subdata.Children = []
                console.log('不存在对应值')
              }
            }
            if (ifhaszhi) {
              console.log('最高层存在数值')
              jmodel.push(subdata)
            } else {
              console.log('最高层不存在数值')
            }
          }
        }
        if (ifjmodel) {
          newdata[0].Children = jmodel
        } else {
          newdata[0].Children = []
        }
      }
      console.log(newdata)
      var insertdatas = []
      for (var h = 0; h < useridlist.length; h++) {
        var insertdata = {
          userid: parseInt(useridlist[h]),
          models: JSON.stringify(newdata)
        }
        insertdatas.push(insertdata)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/permission/papu',
        method: 'post',
        data: insertdatas,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已批量保存权限'
            })
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      console.log(insertdatas)
    },
    addqx () {
      var useridlist = []
      for (var index in this.$refs.pcusertb.selection) {
        var pcuserdata = this.$refs.pcusertb.selection[index]
        useridlist.push(pcuserdata.id.Int64)
        console.log(pcuserdata)
      }
      var newdata = JSON.parse(localStorage.getItem('models'))
      var checklist = this.checkList.join(',')
      console.log(checklist)
      if (checklist === '') {
        newdata = []
      } else {
        var ifjmodel = false
        var jmodel = []
        for (var j = 0; j < newdata[0].Children.length; j++) {
          var ifhaszhi = false
          var subdata = newdata[0].Children[j]
          if (subdata) {
            if (subdata.Children.length > 0) {
              var ptmplen = subdata.Children.length
              var ifkmodel = false
              var imodel = []
              for (var i = 0; i < ptmplen; i++) {
                var subsubdata = subdata.Children[i]
                if (subsubdata) {
                  if (subsubdata.Children.length > 0) {
                    var tmplen = subsubdata.Children.length
                    console.log('执行最小级别循环')
                    var kmodel = []
                    var zmodel = false
                    for (var k = 0; k < tmplen; k++) {
                      var subsubsubdata = subsubdata.Children[k]
                      if (subsubsubdata) {
                        console.log(subsubsubdata.Name)
                        if (checklist.indexOf(subsubsubdata.Name) > -1) {
                          ifkmodel = true
                          ifhaszhi = true
                          ifjmodel = true
                          zmodel = true
                          kmodel.push(subsubsubdata)
                        }
                      }
                    }
                    if (zmodel) {
                      imodel.push(subsubdata)
                    }
                    subsubdata.Children = kmodel
                  }
                }
              }
              if (ifkmodel) {
                console.log('存在对应值')
                subdata.Children = imodel
                console.log(imodel)
              } else {
                subdata.Children = []
                console.log('不存在对应值')
              }
            }
            if (ifhaszhi) {
              console.log('最高层存在数值')
              jmodel.push(subdata)
            } else {
              console.log('最高层不存在数值')
            }
          }
        }
        if (ifjmodel) {
          newdata[0].Children = jmodel
        } else {
          newdata[0].Children = []
        }
      }
      console.log(newdata)
      var insertdatas = []
      for (var h = 0; h < useridlist.length; h++) {
        var insertdata = {
          userid: parseInt(useridlist[h]),
          models: JSON.stringify(newdata),
          cusid: parseInt(that.khid)
        }
        insertdatas.push(insertdata)
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/permission/paaupu',
        method: 'post',
        data: insertdatas,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '已批量保存权限'
            })
          } else {
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
      console.log(insertdatas)
    },
    selectall () {
      var sqlstr = 'app_id = 4'
      that.$http({
        url: 'https://api.sqnetsoft.cn/app/getappmodel',
        method: 'post',
        data: {
          whereinfo: {String: sqlstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            var menudata = []
            var jsondata = res.data.data
            console.log(jsondata)
            for (var t = 0; t < jsondata.length; t++) {
              var jdata = jsondata[t]
              menudata.push(jdata.name)
            }
            console.log(menudata)
            that.checkList = menudata
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    cancelall () {
      this.checkList = []
    },
    querymember () {
      console.log('查询会员信息')
      var qstr
      if (this.khid === '1') {
        qstr = 'id > 0'
      } else {
        qstr = 'cus_id = ' + this.khid
      }
      if (this.customername !== null && this.customername !== '') {
        qstr = qstr + " and cus_id = '" + this.customername + "' "
      }
      if (this.customergroup !== null && this.customergroup !== '') {
        qstr = qstr + " and usergroups_id = '" + this.customergroup + "'"
      }
      if (this.bymemberdate !== null && this.bymemberdate !== '') {
        qstr = qstr + " and optime >= '" + this.bymemberdate[0] + " 00:00:00' and optime<='" + this.bymemberdate[1] + " 23:59:59'"
      }
      console.log(qstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/getcususer',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(res.data.data)
            that.udata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/control/PermissionControll.vue